import React from 'react'
import { Form } from 'react-bootstrap'
import FacilitatorsSelector from '../../facilitators/selector'

const FacilitatorParam = ({
    label,
    value,
    onChange = () => {},
}) => {
    return (
        <Form.Group>
            <Form.Label>{label || 'Facilitator'}</Form.Label>
            <FacilitatorsSelector
                value={value}
                onChange={onChange}
            />
        </Form.Group>
    )
}

export default FacilitatorParam